export default __webpack_public_path__ + "static/media/message.c6def236.png";